import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';

const baseStyles = {
    detailsPopup: {
        width: Device.isWeb ? '45%' : '33%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: 10000,
        borderLeftWidth: 0.5,
        borderColor: 'rgba(255,255,255,0.16)',
        shadowColor: Device.isWeb ? 'rgb(0, 0, 0)' : '#101010',
        shadowOffset: {
            width: Device.isWeb ? 2 : -150,
            height: 0
        },
        shadowOpacity: Device.isWeb ? 0.5 : 0.7,
        shadowRadius: 40.0,
        elevation: 24,
        ...(Device.isWeb ? { maxWidth: 374 } : {}),
        ...(Device.isTablet ? { maxWidth: 460 } : {})
    }
};

export default StyleSheet.create(baseStyles);
